import { DeliverResponseCode } from "../InAppMessageDeliverResponse"
import { InAppMessageDeliverEvaluation } from "./InAppMessageDeliverEvaluation"

export class InAppMessageDeliverEvaluateResponse {
  constructor(
    readonly isEligible: boolean,
    readonly code: DeliverResponseCode | null,
    readonly evaluation: InAppMessageDeliverEvaluation | null
  ) {}

  static ineligible(code: DeliverResponseCode): InAppMessageDeliverEvaluateResponse {
    return new InAppMessageDeliverEvaluateResponse(false, code, null)
  }

  static of(evaluation: InAppMessageDeliverEvaluation): InAppMessageDeliverEvaluateResponse {
    if (!evaluation.eligibility.evaluation.isEligible) {
      return InAppMessageDeliverEvaluateResponse.ineligible("INELIGIBLE")
    }
    return new InAppMessageDeliverEvaluateResponse(true, null, evaluation)
  }
}
